var map = {
	"./01.png": 9353,
	"./02.png": 8642,
	"./03.png": 2859,
	"./blog-thumb/01.png": 5573,
	"./blog-thumb/02.png": 3774,
	"./blog-thumb/03.png": 6791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4346;